var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMistralAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 79.299) scale(1.96335)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h254.667v180H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.33333)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h190.141v135H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd800",
    d: "M27.153 0h27.169v27.089H27.153zM135.815 0h27.169v27.089h-27.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf00",
    d: "M27.153 27.091h54.329V54.18H27.153zM108.661 27.091h54.329V54.18h-54.329z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8205",
    d: "M27.153 54.168h135.819v27.089H27.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fa500f",
    d: "M27.153 81.259h27.169v27.09H27.153zM81.492 81.259h27.169v27.09H81.492zM135.815 81.259h27.169v27.09h-27.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10500",
    d: "M-.001 108.339h81.489v27.09H-.001zM108.661 108.339h81.498v27.09h-81.498z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralAi);
export default __webpack_public_path__ + "static/media/Mistral AI.8d77be4afbbffecfc50bfd8e7e680ceb.svg";
export { ForwardRef as ReactComponent };